import { api } from "./api";

export interface InventoryItem {
  itemId: string;
  name: string;
  sku: string;
  status: string;
  brand: string;
  model: string;
  reference: string;
  rate: number;
  stock: number;
  hasImage: boolean;
  cf: Record<string, string>;
  cfh: Record<string, string>;
}

export interface InventorySerial {
  serialNumber: string;
  billNumber?: string;
  billDate?: string;
  vendorName?: string;
  minted: boolean;
}

export interface InventoryItemDetail {
  item: InventoryItem;
  serials: InventorySerial[];
}

export interface Bill {
  billId: string;
  billNumber: string;
  date: string;
  vendorName: string;
  total: number;
  status: string;
}

export interface BillItem {
  item: InventoryItem;
  serials: InventorySerial[];
}

export interface BillDetail {
  bill: {
    billNumber: string;
    date: string;
    vendorName: string;
    status?: string;
  };
  items: BillItem[];
}

export async function searchInventory(criteria: {
  name?: string;
  sku?: string;
}): Promise<InventoryItem[]> {
  const params: Record<string, string> = {};
  if (criteria.name) params.name = criteria.name;
  if (criteria.sku) params.sku = criteria.sku;
  const { data } = await api.get<{ items: InventoryItem[] }>(
    "/admin/inventory",
    { params }
  );
  return data.items;
}

export async function searchBills(query?: string): Promise<Bill[]> {
  const params: Record<string, string> = {};
  if (query) params.q = query;
  const { data } = await api.get<{ bills: Bill[] }>("/admin/inventory/bills", {
    params,
  });
  return data.bills;
}

export async function getBill(billId: string): Promise<BillDetail> {
  const { data } = await api.get<BillDetail>(
    `/admin/inventory/bills/${encodeURIComponent(billId)}`
  );
  return data;
}

export async function getInventoryItem(
  itemId: string
): Promise<InventoryItemDetail> {
  const { data } = await api.get<InventoryItemDetail>(
    `/admin/inventory/${encodeURIComponent(itemId)}`
  );
  return data;
}
